import { render } from "./Third.vue?vue&type=template&id=0239c510&scoped=true"
import script from "./Third.vue?vue&type=script&lang=js"
export * from "./Third.vue?vue&type=script&lang=js"

import "./Third.vue?vue&type=style&index=0&id=0239c510&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0239c510"]])

export default __exports__